module.exports = __webpack_public_path__ + "img/cover-redeem-bg.0dccfde5.jpg";